import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { GetConnectionDataPayload } from '../Google/Ads/GoogleAds.types';

const GetConnectionData = new ReduxAsyncAction<
  'GET_CONNECTION_DATA',
  { machineName: string; credentialId: string },
  GetConnectionDataPayload
>('GET_CONNECTION_DATA');
GetConnectionData.registerRequest(({ machineName, credentialId }) => {
  return dash_api.get(`/v1/ad-network/${machineName}/connections/${credentialId}`).then(({ data }) => {
    return data;
  });
});
export const GET_CONNECTION_DATA = GetConnectionData.actionNamespaceConstants;
export const getConnectionData = GetConnectionData.request;

export type GetConnectionDataRequestAction = Action<typeof GET_CONNECTION_DATA.request>;

export type GetConnectionDataResponseAction = Action<typeof GET_CONNECTION_DATA.response> & {
  data: GetConnectionDataPayload;
};

export type GetConnectionDataErrorAction = Action<typeof GET_CONNECTION_DATA.error> & {
  data: Record<string, any>;
};
